import { styled } from '@mui/material';

export const ImageContainer = styled('div')<{ coverPhotoUrl?: string }>(({ coverPhotoUrl }) => ({
  width: 48,
  height: 48,
  borderRadius: 8,
  overflow: 'hidden',
  flexShrink: 0,
  ...(coverPhotoUrl
    ? {
        background: `url(${coverPhotoUrl}) lightgray 50% / cover no-repeat, #FFF`,
      }
    : {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        border: '1px solid #e0e0e0',
      }),
}));
